import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'qvs-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: true
})
export class SvgIconComponent implements OnInit, OnChanges {
  @Input() src: string;
  @Input() title: string;
  @ViewChild('iconContainer', { static: true }) iconContainer: ElementRef;

  ngOnInit() {
    this.loadSvg();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.src && !changes.src.isFirstChange()) {
      this.loadSvg();
    }
  }

  private async loadSvg() {
    if (!this.src) {
      return;
    }

    const res = await fetch(this.src);
    this.iconContainer.nativeElement.innerHTML = await res.text();

    const svgElement = this.iconContainer.nativeElement.querySelector('svg');
    if (svgElement) {
      svgElement.setAttribute('part', 'svg');

      if (!!this.title) {
        let titleElement = svgElement.querySelector('title');
        if (!titleElement) {
          titleElement = document.createElement('title');
          svgElement.prepend(titleElement);
        }
        if (this.title) {
          titleElement.textContent = this.title;
        }
      }
    }
  }
}
